import { useState, React, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  Icon,
  ImageList,
  ImageListItem,
  InputAdornment,
  Link,
  TextField,
  AppBar,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { postAPI } from "../../services/basehttpAPI";
import SnackbarComponent from "../../components/snackbar";
import Copyright from "../../components/copyright";

const theme = createTheme();


const ForgotPassword = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [validRegex, setValidRegex] = useState(true);
  const [validusrname, setvalidusrname] = useState(null);
  const [errorusernametext, seterrorusernametext] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setmessage] = useState(null);
  const [severity, setseverity] = useState(null);
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
    useEffect(() => {
        seterrorusernametext(validusrname ? "Por favor incluir Email" /*translatedText.please_enter_emailid*/ : null);
    if (!validusrname && !validRegex)
        seterrorusernametext(!validRegex ? "Email Invalido" /*translatedText.invalid_email*/ : null);
  }, [validRegex, validusrname]);

  const handleClose = () => {
    setOpen(false);
  };

  function handleChange(evt) {
    const value = evt.target.value;
    setUsername({
      ...username,
      [evt.target.name]: value,
    });
  }

  function handleVaild(e) {
    if (e.target.value.trim() !== "") {
      if (e.target.name === "username") {
        const reg = new RegExp("^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$");
        let isValidregex = reg.test(e.target.value);
        setValidRegex(isValidregex);
        setvalidusrname(false);
      }
    } else {
      if (e.target.name === "username") {
        setvalidusrname(true);
      }
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (username != null && validRegex) {
      let url = "authentication/ForgotPassword";
      const { data } = await postAPI(url, username);
      if (data !== null) {
        if (data.isSuccess) {
            setseverity("success");
            setmessage("Email enviado, por favor revisa tu correo"/*translatedText.email_has_been_sent_please_verify*/);
            setOpen(true);
          //navigate("/login");
        } else if (!data.isSuccess) {
          setseverity("error");
            setmessage("Email no valido"/*data.errorMessages*/);
          setOpen(true);
        } else {
            setseverity("error");
            setmessage("Algo salió mal. ¡Por favor, inténtalo de nuevo ¡"/*translatedText.something_went_wrong_please_try_again_sometime*/);
          setOpen(true);
        }
      } else {
        setseverity("error");
          setmessage("Algo salió mal. ¡Por favor, inténtalo de nuevo ¡"/*translatedText.something_went_wrong_please_try_again_sometime*/);
        setOpen(true);
      }
    } else {
      if (username == null) {
        setvalidusrname(true);
      }
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="lg" sx={{ mt: 0, mb: 0, ml: 0 }}>
        <CssBaseline />
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={3}
            sx={{
              backgroundColor: "#D8DDE0CC",
              height: { sm: "100%", md: "100%", lg: "103vh" },
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <ImageList>
              <ImageListItem>
                <img
                  src={process.env.PUBLIC_URL + "/images/box.png"}
                  alt="box"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/deliveryvan.png"}
                  alt="van"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/globe.png"}
                  alt="globe"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/filelock.png"}
                  alt="filelock"
                  className="Loginlogo"
                />
              </ImageListItem>
            </ImageList>
          </Grid>
          <Grid item xs={0}></Grid>
          <Grid item xs={12} sm={7} md={6} lg={5}>
            <img
              src={process.env.PUBLIC_URL + "/images/albaraneslogo.png"}
              alt="logo"
              height="120"
            />
            <Box
              sx={{
                marginTop: "15%",
                display: "flex",
                flexDirection: "column",
              }}
            >
                          <Typography component="h1" variant="h5">
                              {"¿Olvidó / Restablecer contraseña?"/*translatedText.Forgot_reset_password*/}
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 1 }}
              >
                <TextField
                  margin="normal"
                  fullWidth
                  id="username"
                                  label={"Correo Electronico"/*translatedText.email_address*/}
                  name="username"
                  required={true}
                  autoComplete="off"
                  onChange={handleChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Icon>
                          <AccountCircle />
                        </Icon>
                      </InputAdornment>
                    ),
                  }}
                  onBlur={handleVaild}
                  error={errorusernametext !== null ? true : false}
                  helperText={errorusernametext}
                />
                <Grid container>
                  <Grid item xs></Grid>
                  <Grid item style={{ marginTop: 5 }}>
                    <Link
                      href={process.env.PUBLIC_URL + "/login"}
                      variant="body2"
                      underline="hover"
                                      >
                                          {"¿Desea iniciar sesión?"/*translatedText.do_you_want_to_login*/}
                    </Link>
                  </Grid>
                </Grid>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="success"
                  sx={{ mt: 3, mb: 2 }}
                >
                  {" "}
                                  {"Restablecer contraseña"/*translatedText.reset_password*/}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <AppBar
        position="fixed"
        sx={{
          top: "auto",
          bottom: 0,
          backgroundColor: "white",
          zIndex: "0",
          boxShadow: "0",
          width: { xs: "100%", sm: "90%", md: "62%", lg: "75%", xl: "80%" },
        }}
      >
        <Copyright align="left" />
      </AppBar>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </ThemeProvider>
  );
};

export default ForgotPassword;
